import React from 'react';
import BaseInput from '../ui/BaseInput';
import { Button } from '../ui';
import { LoginFormData } from '../../types/auth';

interface LoginFormProps {
  onSubmit: (data: LoginFormData) => void;
  loading?: boolean;
  onSwitchToSignUp?: () => void;
  fieldErrors?: Record<string, string>;
  generalError?: string | null;
}

const LoginForm = (props: LoginFormProps) => {
  const [formData, setFormData] = React.useState<LoginFormData>({
    email: '',
    password: '',
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    props.onSubmit(formData);
  };

  const handleChange = (field: keyof LoginFormData) => (value: string) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const { fieldErrors = {}, generalError } = props;
  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {generalError && (
        <div className="mb-2 p-2 bg-red-50 border border-red-200 rounded-md text-red-600 text-sm text-center">
          {generalError}
        </div>
      )}
      <BaseInput
        label="Email Address"
        name="email"
        type="email"
        value={formData.email}
        onChange={handleChange('email')}
        error={fieldErrors.email}
        required
        autoComplete="email"
        placeholder="Email Address"
      />

      <BaseInput
        label="Password"
        name="password"
        type="password"
        value={formData.password}
        onChange={handleChange('password')}
        error={fieldErrors.password}
        required
        autoComplete="current-password"
        placeholder="Password"
      />

      <Button
        type="submit"
        loading={props.loading}
        className="w-full py-3 bg-brand-dark-blue hover:bg-brand-electric-blue text-white font-medium rounded-md mt-3"
      >
        Log In
      </Button>

      <p className="text-center text-sm text-gray-600 mt-2">
        Don't have an account? <a href="#" className="text-brand-electric-blue hover:text-brand-dark-blue" onClick={(e) => {
          e.preventDefault();
          props.onSwitchToSignUp?.();
        }}>Sign Up</a>
      </p>
    </form>
  );
};

export { LoginForm };